import firebase from 'firebase'

let firebaseConfig
// if (process.env.NODE_ENV == "production") {
if (process.env.NODE_ENV == "development" || location.host == "test-mfp-devlopment.firebaseio.com" || location.host == "test-mfp-development.firebaseapp.com") {
  firebaseConfig = {
    apiKey: "AIzaSyAX3XQ3J5maRnMy6dx_NSGqIyCCNEkOn4g",
    authDomain: "test-mfp-development.firebaseapp.com",
    databaseURL: "https://test-mfp-devlopment.firebaseio.com",
    projectId: "test-mfp-development",
    storageBucket: "",
    messagingSenderId: "498315399105"
  }
} else {
  firebaseConfig = {
    apiKey: "AIzaSyBKODydavZ0k0IBYmZgLtzzJZB87BJPT_0",
    authDomain: "mfp-devlopment.firebaseapp.com",
    databaseURL: "https://mfp-devlopment.firebaseio.com",
    projectId: "mfp-devlopment",
    storageBucket: "",
    messagingSenderId: "779671453851"
  }
}
// } else {
// firebaseConfig = {
//   apiKey: "AIzaSyAX3XQ3J5maRnMy6dx_NSGqIyCCNEkOn4g",
//   authDomain: "test-mfp-development.firebaseapp.com",
//   databaseURL: "https://test-mfp-devlopment.firebaseio.com",
//   projectId: "test-mfp-development",
//   storageBucket: "",
//   messagingSenderId: "498315399105"
// }
// }
console.log(firebaseConfig.projectId)


firebase.initializeApp(firebaseConfig)
//firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

export default firebase